import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Info from '../../Info';
import DropdownClassic from "../../../components/DropdownClassic"

// Import utilities
import { tailwindConfig } from '../../../utils/Utils';

function KeywordInfoCard({title, data, hint}) {

  const [selectedItem, setSelectedItem] = useState(null);
  const [index, setIndex] = useState(0);

  function updateSelectedItem(){
    if(index===data.length-1) {
      setIndex(0)
      setSelectedItem(data[0])
    }
    else {
      setIndex(index + 1)
      setSelectedItem(data[index + 1])
    }
  }

  useEffect(() => {
    setIndex(0)
    if(data.length>0)
      setSelectedItem(data[0])
  }, [data]);

  return (
    /*<div className="bg-white p-5 shadow-1 rounded-sm border border-slate-200 lg:w-72 xl:w-80">
      <header className="px-5 py-4 border-b border-slate-100 flex items-center">
        <h2 className="font-semibold text-slate-800">{title}</h2>
        <Info className="ml-auto" containerClassName="min-w-80">
          <div className="text-sm">{hint}</div>
        </Info>
      </header>
      <div className="grow p-3">
        <div className="flex flex-col h-full">
          {/!* Card content *!/}
          <div className="grow">
            {/!*{infoItems}*!/}
            <h1>Russia</h1>
            <p>this is some abstract</p>
          </div>
          {/!* Card footer *!/}
          {/!*<div className="text-center pt-4 pb-1 border-t border-slate-100">
            <Link className="text-sm font-medium text-yellow-500 hover:text-yellow-600" to="#0">Channels Report -&gt;</Link>
          </div>*!/}
        </div>
      </div>
    </div>*/

      <div className="col-span-full md:col-span-6 xl:col-span-4 p-2 bg-white shadow-1 rounded-sm border border-slate-200
         overflow-hidden lg:w-72 xl:w-80 mb-3">
        {selectedItem!=null?
        <div className="flex flex-col h-full">
          {/* Image */}
          <div className="relative">
            {selectedItem.image!=''?
              <img className="h-full m-auto max-h-48 object-cover" src={"https://duckduckgo.com/"+selectedItem.image} width="201" height="126" alt="Application 22"/>
              :''
            }
          </div>
          {/* Card Content */}
          <div className="grow flex flex-col p-5 w-full">
            {/* Card body */}
            <div className="grow">
              <header className="mb-2">
                <div>
                  <h3 className="text-lg text-slate-800 font-semibold mb-1">{selectedItem.heading}</h3>
                </div>
                <div className="text-sm line-clamp-6">{selectedItem.abstract}</div>
              </header>
            </div>
            {/* Rating and price */}
            <div className="flex flex-wrap justify-between">
              <div>
                <a className="btn-xs bg-gray-400 hover:bg-gray-500 text-white" href={selectedItem.url}
                   target="_blank">More Info</a>
              </div>
              <div className="">
                <button className="btn-xs bg-pink-400 hover:bg-pink-500 text-white" onClick={()=>updateSelectedItem()}>Next</button>
              </div>
            </div>
          </div>
        </div>
          :
          <div className="flex flex-col h-full">
            {/* Card Content */}
            <div className="grow flex flex-col p-5 w-full">
              {/* Card body */}
              <div className="grow">
                <header className="mb-2">
                  <div>
                    <h3 className="text-lg text-slate-800 font-semibold mb-1">Keyword Info</h3>
                  </div>
                  <p className="text-sm">Select a keyword from the chart to learn more about it.</p>
                </header>
              </div>
            </div>
          </div>}
      </div>
  );
}

export default KeywordInfoCard;
